import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getToday } from '@common/utils/date';
import SatCheckBox from '@components/common/satUI/SatCheckBox';
import {
  checkEaDisabled,
  checkEaStatusReady,
  toCurrency,
} from '@common/utils/index';
import SatButton from '@components/common/satUI/SatButton';
import SatDataGrid from '@components/common/satUI/SatDataGrid';
import SatModal from '@components/common/satUI/SatModal';
import { changeFavoriteYn } from '@store/actions/eaAction';
import { gender } from '@common/utils/gender';
/* @NOTE: 고객(Customer) 폴더 사용 Component 경로 변경으로 업데이트 (추가 업데이트 예정) */
import { PinnedCustomerStatus } from '@container/customer';
import SatInput from '@components/common/satUI/SatInput';
import ComingSoonPopup from '@components/common/ComingSoonPopup';
import { useMapState } from 'rooks';
import { PLAN_PROGRESS_STATUS_INFO } from '@common/constants';
import SkipEaAvailableCheckbox from './SkipEaAvailableCheckbox';

const ConstractList = props => {
  const {
    planList,
    onChangeCheckBox,
    searchParam,
    onClickSortBtn,
    onClickPdfViewerBtn,
    onClickPlanDetail,
    onClickElctronicBtn,
    onClickChangeTitleBtn,
    onClickOmniBtn,
    onClickProgressBtn,
    onClickOmniCancelBtn,
    onScroll,
    isLogin,
    searchNameRef,
    customerName,
    onClickDeleteSearchName,
    onChangeSearchName,
    onPressEnter,
    customerInfo,
    onClickLogoutBtn,
  } = props;

  const dispatch = useDispatch();

  const { searchSuitability } = $hooks.useApi();
  const { info: toastInfo, dismiss: toastDismiss } = $hooks.useToast();
  const { alert } = $hooks.useModal();
  const { checkPlanBeforeOpen } = $hooks.useEa();

  const [commingSoon, setCommingSoon] = useState(false);

  // 현재 클릭한 Row 데이터
  const [clickedRow, setClickedRow] = useState({});

  // 현재 클릭한 청약진행여부버튼 여부
  const [isConstractChange, setIsConstractChange] = useState(false);

  // 재발행 미결상태인 경우 팝업 체크
  const [isUndecidedPopup, setIsUndecidedPopup] = useState(false);

  // 같은 증권번호 접수 상태에서 다시 청약 진행시 팝업
  const [isAlreadyPolicyPopup, setIsAlreadyPolicyPopup] = useState(false);

  // 변액/외화 적합성 미접수 상태 정보
  const [
    suitabilityIncompleteInfo,
    { setMultiple: setSuitablityIncompleteInfo },
  ] = useMapState({
    reportSerialNo: '',
    usdSerialNo: '',
    suitabilityStatus: '', // 1: 변액적합성 2: 외화적합성 3: 변액 + 외화
    isShow: false,
  });

  const showSuitabilityIncomplete = suitabilityInfo =>
    setSuitablityIncompleteInfo({ ...suitabilityInfo, isShow: true });
  const hideSuitabilityIncomplete = () =>
    setSuitablityIncompleteInfo({
      type: '',
      reportSerialNo: '',
      usdSerialNo: '',
      isShow: false,
    });

  // 변액/외화 적합성이 미접수 상태인지 확인
  const checkSuitabilityComplete = suitabilityInfo => {
    const {
      suitabilityStatus,
      usdSuitabilityStatus,
      reportSerialNo,
      usdSerialNo,
    } = suitabilityInfo;
    let type;

    const incompleteStatuses = ['3', '4'];
    const isVariableIncomplete = incompleteStatuses.includes(suitabilityStatus);
    const isUsdIncomplete = incompleteStatuses.includes(usdSuitabilityStatus);

    if (isVariableIncomplete && isUsdIncomplete) {
      type = 'both'; // 변액 + 외화
    } else if (isVariableIncomplete) {
      type = 'variable'; // 변액 + 외화
    } else if (isUsdIncomplete) {
      type = 'usd';
    }

    if ($utils.isEmptyString(type)) return true;
    else {
      showSuitabilityIncomplete({ type, reportSerialNo, usdSerialNo });
      return false;
    }
  };

  // 가입 설계 내용 설계 타입 라벨
  const constractTypeLabelRender = row => {
    return (
      <>
        {(row.republishYn === 'Y' || row.rePublishYn === 'Y') && (
          <span className="type-label2">{`재발행`}</span>
        )}
        {$utils.isTrue(row.lmtExcdProgrsYn) && (
          <span className="type-label2">{`한도초과`}</span>
        )}
        {row.jointApplicationYn === 'Y' && (
          <span className="type-label">{`공동`}</span>
        )}
        {row.isConversionPlan && <span className="type-label">{`전환`}</span>}
        {row.progressStep === PLAN_PROGRESS_STATUS_INFO.omniCanceled && (
          <span className="type-label">{`옴니취소`}</span>
        )}
      </>
    );
  };

  // 동일 건 재발행 작성 완료 여부 + 미결회송 완료 상태 ,( 완료 접수 건 제외 나머지들 )
  const getIsRepublishDisabled = useCallback(row => {
    // 완료한 접수 건 은 제외
    if (row.progressStep === 'R' || row.progressStep === 'T') return false;

    // 동일 재발행 건 완료 여부 (미결회송 완료 상태)
    if (
      row.republishYn === 'Y' &&
      row.isRepublishDisabled &&
      (row.undecidedYn === 'N' || !row.undecidedYn)
    )
      return true;

    return false;
  }, []);

  // 기 발행 건 - 동일 건 재발행 작성 완료 여부 + 미결회송을 하지 않은 상태 ,( 완료 접수 건 제외 나머지들 )
  const getIsAlreadyEqualPolicyAccess = useCallback(row => {
    // 완료한 접수 건 은 제외
    if (row.progressStep === 'R' || row.progressStep === 'T') return false;

    // 동일 재발행 건 완료 여부 (미결회송을 하지 않은 상태)
    if (row.republishType === 'DOC') {
      if (
        row.republishYn === 'Y' &&
        row.alreadyEqualPolicyAccessYn &&
        (row.undecidedYn === 'Y' || row.undecidedYn)
      )
        return true;
    } else {
      if (
        row.republishYn === 'Y' &&
        row.isRepublishDisabled &&
        (row.undecidedYn === 'Y' || row.undecidedYn)
      )
        return true;
    }

    return false;
  }, []);

  // isConstractChange : 청약 변경 진행 여부
  const handleMobileEa = async (row, isConstractChange = false) => {
    // 청약 발행 날짜 확인하여, Open 기준 날짜(2024-03-01) 이전이면 알림 후 오픈되지 않도록 함
    const isBeforeOpenDate = checkPlanBeforeOpen(row.planEstablishDate);
    if (isBeforeOpenDate) return;

    // 미결건 이 아니다 팝업 (발송취소 x 버튼은 동작 안함)
    if (getIsRepublishDisabled(row)) {
      setIsUndecidedPopup(true);
      return;
    } else if (row.progressStep !== 'P' && getIsAlreadyEqualPolicyAccess(row)) {
      // 발송 취소는 제외 (row.progressStep !== 'P')
      // 현재 클릭한 Row 데이터
      setClickedRow(row);
      // 현재 클릭한 청약진행여부버튼 여부
      setIsConstractChange(isConstractChange);

      // 기 작성건이 있다는 팝업
      setIsAlreadyPolicyPopup(true);
      return;
    }

    // [Robin]: 변액/외화 적합성 가입설계인 경우, 적합성 정보 확인
    const isSuitabilityPlan = $utils.checkSuitabilityPlan(row);
    // 전문금융인
    const isProFinance = $utils.checkFinancialExpert({ jobCode: row.jobCd });
    if (!isProFinance && isSuitabilityPlan) {
      // 적합성 정보 조회
      const response = await searchSuitability({
        params: { applicationNo: row.applicationNo },
      });
      const suitabilityInfo = $utils.getApiData(response);

      // 적합성 정보가 존재하지 않으면 청약 불가
      const isSuitabilityExist = $utils.checkSuitabilityExist(suitabilityInfo);
      if (!isSuitabilityExist) {
        return alert({
          message:
            '지금 청약문서를 발행하는 중입니다. 잠시 후에 다시 시도해 주세요.',
        });
      }

      // 적합성이 서면(미접수) 상태라면 팝업 노출 후 청약 불가
      const isSuitabilityComplete = checkSuitabilityComplete(suitabilityInfo);
      if (!isSuitabilityComplete) return showSuitabilityIncomplete();
    }

    handleConstractProgress(row, isConstractChange);
  };

  // 청약 작성 진행 시작
  const handleConstractProgress = (row, isConstractChange = false) => {
    const progressStep = row.progressStep;
    const isEaStatusReady = checkEaStatusReady(progressStep);

    if (isEaStatusReady) onClickProgressBtn(row, isConstractChange);
    else if (progressStep === 'Q') onClickElctronicBtn(row, isConstractChange);
    else if (progressStep === 'O') onClickOmniBtn(row, isConstractChange);
    else if (progressStep === 'P' && !getIsRepublishDisabled(row))
      onClickOmniCancelBtn(row);
    else return;
  };

  // 서면 청약서 출력
  const handleWritingConstractPrint = useCallback(row => {
    if (getIsRepublishDisabled(row)) {
      setIsUndecidedPopup(true);
    } else {
      setCommingSoon(true);
    }
  }, []);

  const MobileEapp = ({ row, onClick }) => {
    const { progressStep, republishType, omnSysCreateDate } = row;

    // 기존 조건
    const isEaStatusReady = checkEaStatusReady(progressStep);
    const [isDisabled] = useState(
      (!isEaStatusReady && republishType === 'PND') || republishType === 'OP',
    );
    const isRepublishDisabled = getIsRepublishDisabled(row);

    // 신규 청약 불가 조건
    const isEaDsiabled = checkEaDisabled(row);

    return progressStep === 'P' &&
      republishType !== 'PND' &&
      !isRepublishDisabled ? (
      <MobileOmniCancel
        label={$utils.getPlanButtonLabel({
          progressStep,
          republishType,
        })}
        onClick={onClick}
      />
    ) : (
      <SatButton
        // 동일 건에 대해 재발행 완료 있을시 버튼 비활성화 표시 되고 클릭시 미결이 아니라는 팝업
        styleClass={`btn-s dark-gray btn-full ${
          isRepublishDisabled ||
          isEaDsiabled ||
          (progressStep === 'Q' && getToday('yyyyMMdd') !== omnSysCreateDate)
            ? 'disabled'
            : ''
        }`}
        label={$utils.getPlanButtonLabel({
          // 청약변경으로 진행 중 일때 초기 N으로 라벨
          progressStep: isDisabled || isRepublishDisabled ? 'N' : progressStep,
          republishType,
        })}
        onClick={onClick}
        disabled={
          // 기존 조건 유지
          ((['R', 'T'].includes(progressStep) || isDisabled) &&
            !isRepublishDisabled) ||
          // 신규 청약 불가 조건
          isEaDsiabled
        }
      />
    );
  };

  const MobileEappPnd = ({ row, onClick }) => {
    const { progressStep, republishType } = row;
    const isEaStatusReady = checkEaStatusReady(progressStep);
    const [isDisabled] = useState(!isEaStatusReady && republishType === 'ALL');
    const BUTTON_LABEL = {
      N: '모바일 청약변경 진행',
      C: '모바일 청약변경 진행',
      Q: '대면 청약변경 작성 중',
      R: '대면 청약변경 작성 완료',
      O: '옴니 청약변경 작성 중',
      P: '옴니 청약변경 발송 완료',
      T: '옴니 청약변경 작성 완료',
    };

    return progressStep === 'P' &&
      republishType === 'PND' &&
      !getIsRepublishDisabled(row) ? (
      <MobileOmniCancel label={BUTTON_LABEL[progressStep]} onClick={onClick} />
    ) : (
      <SatButton
        // 동일 건에 대해 재발행 완료 있을시 버튼 비활성화 표시 되고 클릭시 미결이 아니라는 팝업
        styleClass={`btn-s dark-gray btn-full ${
          getIsRepublishDisabled(row) ? 'disabled' : ''
        }`}
        label={
          // 그냥 청약으로 진행 중 일때 초기 N으로 라벨
          BUTTON_LABEL[
            isDisabled || getIsRepublishDisabled(row) ? 'N' : progressStep
          ]
        }
        onClick={onClick}
        disabled={
          (['R', 'T'].includes(progressStep) || isDisabled) &&
          !getIsRepublishDisabled(row)
        }
      />
    );
  };

  const MobileEappDoc = ({ row, onClick }) => {
    const { progressStep } = row;
    const BUTTON_LABEL = {
      N: '미결서류보완',
      C: '미결서류보완',
      Q: '대면 미결보완 작성 중',
      R: '대면 미결보완 작성 완료',
      O: '옴니 미결보완 작성 중',
      P: '옴니 미결보완 발송 완료',
      T: '옴니 미결보완 작성 완료',
    };

    return progressStep === 'P' && !getIsRepublishDisabled(row) ? (
      <MobileOmniCancel label={BUTTON_LABEL[progressStep]} onClick={onClick} />
    ) : (
      <SatButton
        styleClass={`btn-s dark-gray btn-full ${
          getIsRepublishDisabled(row) ? 'disabled' : ''
        }`} // 동일 건에 대해 재발행 완료 있을시 버튼 비활성화 표시 되고 클릭시 미결이 아니라는 팝업
        label={BUTTON_LABEL[getIsRepublishDisabled(row) ? 'N' : progressStep]}
        onClick={onClick}
        disabled={
          ['R', 'T'].includes(progressStep) && !getIsRepublishDisabled(row)
        }
      />
    );
  };

  const MobileOmniCancel = ({ label, onClick }) => {
    return (
      <button type="button" className="btn-s dark-loding btn-full">
        <span>
          {label}
          <i className="ico ico-del3" onClick={onClick} />
        </span>
      </button>
    );
  };

  const handleClickFavorite = (planEstablishNo, currentFavoriteYn) => {
    toastDismiss();
    const toggleFavoriteYn = currentFavoriteYn === 'Y' ? 'N' : 'Y';
    const callback = favoriteYn => {
      toastInfo(
        favoriteYn === 'Y'
          ? '즐겨찾기로 추가되었습니다.'
          : '즐겨찾기가 해제되었습니다.',
      );
    };

    dispatch(
      changeFavoriteYn({
        planEstablishNo,
        favoriteYn: toggleFavoriteYn,
        callback,
      }),
    );
  };

  const columns = [
    {
      title: '선택',
      width: '8.2rem',
      key: 'isChecked',
      align: 'left',
      render: (value, row) => {
        return (
          <div className="t-col-wrap">
            <div className="check-area">
              <div className="check-wrap chk-style only">
                <SatCheckBox
                  value={[row.isChecked]}
                  options={[{ label: '', value: false }]}
                  onChange={() => onChangeCheckBox(row)}
                />
              </div>
            </div>
            {row.planEstablishNo && (
              <div
                className={$classNames('ico', {
                  'ico-favorite': row.favoriteYn !== 'Y',
                  'ico-favorite2': row.favoriteYn === 'Y',
                })}
                onClick={() =>
                  handleClickFavorite(row.planEstablishNo, row.favoriteYn)
                }
              />
            )}
          </div>
        );
      },
    },
    {
      title: (
        <>
          설계일자 <em>(산출일자)</em>
        </>
      ),
      width: '14rem',
      key: 'planEstablishDate',
      dataIndex: 'planEstablishDate',
      sortable: true,
      render: (value, row) => {
        return (
          <>
            <span className="t-date w-120">{row.planEstablishDate}</span>
            <span className="t-date small">({row.calculateDate})</span>
            {row.beffatUndwText && (
              <span className="status-label prelim">{row.beffatUndwText}</span>
            )}
            {(row.progressStep === 'R' || row.progressStep === 'T') && (
              <span className="status-label receipt">청약 접수</span>
            )}
            {row.progressStep === 'D' && (
              <span className="status-label complete">정상(인수)</span>
            )}
          </>
        );
      },
    },
    {
      title: '고객명 / 설계 제목',
      width: '13rem',
      key: 'ownerName',
      align: 'center',
      render: (value, row) => {
        return (
          <>
            {row.virtlPlanYn === 'Y' ? (
              <>
                <span className="customer">{`${row.virtlCustAge}세/${gender(
                  row.genderCode,
                )} (가상설계)`}</span>
                <span
                  className="inp-edit"
                  onClick={() => onClickChangeTitleBtn(row)}
                >
                  <span className="name">{row.planEstablishTitle}</span>
                </span>
              </>
            ) : row.ownerName === row.insuredName ? (
              <>
                <span className="customer">{row.ownerName}</span>
                <span
                  className="inp-edit"
                  onClick={() => onClickChangeTitleBtn(row)}
                >
                  <span className="name">{row.planEstablishTitle}</span>
                </span>
              </>
            ) : (
              <>
                <span className="customer">
                  계약자 : {row.ownerName}
                  <br />
                  피보험자 : {row.insuredName}
                </span>
                <span
                  className="inp-edit"
                  onClick={() => onClickChangeTitleBtn(row)}
                >
                  <span className="name">{row.planEstablishTitle}</span>
                </span>
              </>
            )}
          </>
        );
      },
    },
    {
      title: '가입 설계 내용',
      width: '',
      key: 'mainProductName',
      render: (value, row) => {
        return (
          <div className="t-row-wrap">
            <div className="icon_box">
              {/* Pru / KB 상품 표시 제거 */}
              {/* <span className="ico2 ico-k disib"></span> */}
              {/* <span className="ico2 ico-p disib"></span> */}
              <span className="ico2 disib"></span>

              <div
                className="insu-tit u-line"
                onClick={() => onClickPlanDetail(row)}
              >
                {constractTypeLabelRender(row)}
                {row.mainProductName}
              </div>
            </div>
            <div className="plan-info4">
              <ul>
                {row.premium > 0 && (
                  <li>
                    {`보험료 : ${
                      row.currencyUsdYN === 'N'
                        ? toCurrency(row.premium) + '원'
                        : toCurrency(row.premium, 2) + '달러'
                    }`}
                  </li>
                )}
                {row.applicationNo !== null &&
                  row.applicationNo !== row.beffatUndwNo && (
                    <li>
                      {row.aplctnDvcTyCd === '02' ? '모바일' : ''}발행번호 :{' '}
                      {row.applicationNo}
                    </li>
                  )}
                {row.newbizPolicyNo && <li>증권번호 : {row.newbizPolicyNo}</li>}
                {row.beffatUndwNo && <li>사전심사번호 : {row.beffatUndwNo}</li>}
              </ul>
            </div>
          </div>
        );
      },
    },
    {
      title: '발행 문서',
      width: '16rem',
      key: 'btnGroup',
      render: (value, row) => {
        const {
          isSuggestBtn,
          isEappAvailable,
          isMobileEappBtn,
          isMobileEappPnd,
          isMobileEappDoc,
          isPaperPrintBtn,
        } = $utils.getPlanDisplayButtons(row);

        return (
          <>
            {
              <div className="btn-group tbl-group-wide">
                {isSuggestBtn && ( // sat-2815 고액사전심사신청 건은 가입 제안서 미 노출
                  <SatButton
                    styleClass="btn-s dark-gray btn-full active"
                    label={'가입제안서'}
                    onClick={() => onClickPdfViewerBtn(row)}
                  />
                )}

                {isEappAvailable && (
                  <>
                    {isMobileEappBtn && (
                      <MobileEapp
                        row={row}
                        onClick={() => {
                          handleMobileEa(row);
                        }}
                      />
                    )}

                    {isMobileEappPnd && ( // 청약변경 가능 여부
                      <MobileEappPnd
                        row={row}
                        onClick={() => {
                          handleMobileEa(row, true);
                        }}
                      />
                    )}

                    {isMobileEappDoc && (
                      <MobileEappDoc
                        row={row}
                        onClick={() => {
                          handleMobileEa(row);
                        }}
                      />
                    )}
                  </>
                )}

                {isPaperPrintBtn && (
                  <SatButton
                    styleClass={`btn-s dark-gray btn-full ${
                      getIsRepublishDisabled(row) ? 'disabled' : ''
                    }`}
                    label={'서면 청약서 출력'}
                    onClick={() => handleWritingConstractPrint(row)}
                  />
                )}
              </div>
            }
          </>
        );
      },
    },
  ];

  const sortingOption = [
    {
      sortBy: 'planEstablishDate',
      order: searchParam.sort.includes('desc') ? 'desc' : 'asc',
    },
  ];

  const handleChangeSearchName = value => {
    onChangeSearchName(value);

    // 검색어 빈 값일 경우 검색하지 않음
    // if (value === '') {
    //   onClickDeleteSearchName();
    // } else {
    //   onChangeSearchName(value);
    // }
  };

  return (
    <>
      <div className="tbl-header">
        {/* 조회기간 삭제 */}
        {/* {searchParam.favoriteType === 'Y' && (
          <p className="text-info2 ico-type mgt-4 mgb-16">
            구.푸르덴셜 상품만 확인 가능합니다.
          </p>
        )} */}
        <div className="right-area">
          {/* 회사선택 삭제 */}
          {/* <SatSelect
            title={'회사선택'}
            value={compCd}
            options={[
              { label: '전체', value: 'ALL' },
              { label: '구.KB', value: PRODUCT_COMP_CD.kb },
              { label: '구.푸르덴셜', value: PRODUCT_COMP_CD.pr },
            ]}
            initOption={{ label: '', value: '', useOption: false }}
            readOnly={false}
            onChange={value => handelSelectCompay(value)}
            // validRule={[
            //   {
            //     rule: () => !row.validErrStatus.includes('payinPeriodInfo'),
            //   },
            // ]}
            size="small"
            border={true}
          /> */}
          {/* className: tab-right -> sch-box로 변경 <div className: item search > 삭제 ,  */}

          {/* 개발에서만 보이는 개발 기능 */}
          {$utils.isShowDevFunction && <SkipEaAvailableCheckbox />}

          <div style={{ display: 'none' }}></div>
          <div className="sch-box">
            {!isLogin || !customerInfo?.customerInfo ? (
              <SatInput
                type="search"
                ref={searchNameRef}
                placeholder="이름으로 가입 설계 내용을 검색하세요."
                value={customerName}
                onChange={value => handleChangeSearchName(value)}
                onPressEnter={() => onPressEnter()}
              />
            ) : (
              <div className="custom-sch-box">
                <PinnedCustomerStatus
                  name={customerInfo.customerInfo.name}
                  rsdn={customerInfo.customerInfo.rsdn}
                  genderLabel={customerInfo.customerInfo.genderLabel}
                  custKind={customerInfo.customerInfo.custKind}
                  onClear={onClickLogoutBtn}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <SatDataGrid
        columns={columns}
        dataSource={planList}
        customStyleClass="bd-b-fix"
        sortingOption={sortingOption}
        onSortChange={() => onClickSortBtn()}
        noDataRender={'검색결과가 없습니다.'}
        setRowStyle={row => {
          if (row.progressStep === 'R' || row.progressStep === 'T') {
            return 'bg-receipt';
          } else if (row.progressStep === 'D') {
            return 'bg-complete';
          } else {
            return '';
          }
        }}
        useHeaderPinned
        onScroll={onScroll}
      />

      <ComingSoonPopup
        visible={commingSoon}
        setVisible={() => setCommingSoon(false)}
      />

      <SatModal
        visible={isUndecidedPopup}
        setVisible={() => {
          setIsUndecidedPopup(false);
        }}
        type="info"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text info text-center">
                  {`해당 계약은 미결 중인 상태가 아닙니다.`} <br />
                  {`보완 진행은 미결중인 상태에서만 가능해요.`}
                </p>
              </div>
              <div className="layer-footer">
                <SatButton
                  styleClass="btn-s blue btn-wide"
                  label={'확인'}
                  onClick={() => {
                    setIsUndecidedPopup(false);
                  }}
                />
              </div>
            </>
          );
        }}
      />

      <SatModal
        visible={isAlreadyPolicyPopup}
        setVisible={() => {
          setIsAlreadyPolicyPopup(false);
        }}
        type="confirm"
        render={() => {
          return (
            <>
              <div className="cont">
                <p className="layer-text info text-center">
                  {`증권번호 ${clickedRow.policyNo}로`}
                  <br />
                  {`청약접수가 되어있는 상태입니다.`}
                  <br />
                  {`해당 청약서류보완을 진행할 경우`}
                  <br />
                  {`마지막에 작성한 서류로 반영됩니다.`}
                  <br />
                  <br />
                  {`청약서류보완을 진행하시겠어요?`}
                </p>
              </div>
              <div className="btn-group">
                <SatButton
                  styleClass="btn-half cancel"
                  label={'취소'}
                  onClick={() => setIsAlreadyPolicyPopup(false)}
                />
                <SatButton
                  styleClass="btn-half confirm"
                  label={'확인'}
                  onClick={() => {
                    setIsAlreadyPolicyPopup(false);
                    setTimeout(
                      () =>
                        handleConstractProgress(clickedRow, isConstractChange),
                      200,
                    );
                  }}
                />
              </div>
            </>
          );
        }}
      />

      <SatModal
        type="info"
        visible={suitabilityIncompleteInfo.isShow}
        setVisible={hideSuitabilityIncomplete}
        render={() => (
          <>
            <div className="cont">
              <p className="layer-text text-center">
                {`서면 진행한`}
                <br />

                {/* 외화 적합성이 미접수 상태인 경우 */}
                {['both', 'usd'].includes(suitabilityIncompleteInfo.type) && (
                  <>
                    {`외화보험 적합성진단지`}
                    <span className="c-red">{`(${suitabilityIncompleteInfo.usdSerialNo})`}</span>
                    <br />
                  </>
                )}

                {/* 변액 적합성이 미접수 상태인 경우 */}
                {['both', 'variable'].includes(
                  suitabilityIncompleteInfo.type,
                ) && (
                  <>
                    {`변액보험 적합성진단지`}
                    <span className="c-red">{`(${suitabilityIncompleteInfo.reportSerialNo})`}</span>
                    <br />
                  </>
                )}

                {`고객서명 및 접수가 필요합니다.`}
                <br />
                <span className="c-red">{`미접수시 해당 청약서 접수가 불가합니다.`}</span>
              </p>
            </div>

            <div className="layer-footer">
              <SatButton
                styleClass="btn-s blue btn-wide"
                label={'확인'}
                onClick={hideSuitabilityIncomplete}
              />
            </div>
          </>
        )}
      />
    </>
  );
};
export default ConstractList;

/**
 * 계획수립 진행단계 코드
 * N : 계획수립
 * Q : 대면 전자청약 작성중
 * R : 대면 전자청약 작성완료
 * O : 모바일 옴니청약 작성중
 * P : 모바일 옴니청약 발송완료
 * T : 모바일 옴니청약 작성완료
 * C : 모바일 옴니청약 발송취소
 * A : 서면청약 작성중
 * S : 서면청약 작성완료
 * D : 정상인수(심사완료)
 */
